export const AUDIT_LOG_DETAILS_PANEL = 'AUDIT_LOG_DETAILS_PANEL';
export const AUDIT_LOG_PANEL_WIDTH = 400; // Increased from 365px

// Simple module-level state for sharing audit log event data
let currentAuditLogEvent: any | null = null;

export const setAuditLogEvent = (event: any) => {
	currentAuditLogEvent = event;
};

export const getAuditLogEvent = () => {
	return currentAuditLogEvent;
};

export const clearAuditLogEvent = () => {
	currentAuditLogEvent = null;
};
